module.exports = __webpack_public_path__ + "img/exhibition.e508ff86.png";